module.exports = __webpack_public_path__ + "static/media/webappDesktopCard.0dad1b6f.png";